import { Component, OnInit, Input, Output, HostBinding, EventEmitter, ViewEncapsulation, HostListener } from '@angular/core';
import { IdService } from '../../../shared/services/id.service';

@Component({
	selector: '[rbc-menu-item]',
	templateUrl: './menu-item.component.html',
	styleUrls: ['./menu-item.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class MenuItemComponent implements OnInit {
	@HostBinding('id') @Input() id: string;
	@HostBinding('class') @Input('class') classList: string = '';
	@HostListener('click', ['$event']) onClick(e) {
		this.clickHandler(e);
	}

	@Input() href: string;
	link: string;
	@Input() divider: boolean;
	@Input() icon: string;
	@Input() iconWeight: string;
	@Input() router: boolean;
	@Input() routerTo: string;
	@Input() target: string = '_blank';

	@Output() clickEvent = new EventEmitter();

	constructor(private idService: IdService) {
		this.id = idService.generate();
	}

	ngOnInit() {
		this.link = this.href ? this.href : null;
		this.classList = [this.classList, 'menu-item', this.divider ? 'menu-divider' : null].filter(i => !!i).join(' ');
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
	}

	clickHandler(e) {
		this.clickEvent.emit(e);
	}
}
